var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7979",
    "data-name": "Group 7979",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.956,
    height: 24,
    viewBox: "0 0 19.956 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10050",
    "data-name": "Rectangle 10050",
    width: 19.956,
    height: 24,
    fill: "#734bd1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7978",
    "data-name": "Group 7978",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53671",
    "data-name": "Path 53671",
    d: "M19.895,4.212c-.137-.42-.279-.839-.422-1.258a1.044,1.044,0,0,0-1.137-.818H13.706a7.537,7.537,0,0,0-.106-1.1A1.459,1.459,0,0,0,12.484,0H7.521C6.352.335,6.218,1.131,6.31,2.136H1.641a1.053,1.053,0,0,0-1.15.835C.33,3.443.164,3.914,0,4.385v.3a.807.807,0,0,0,.858.5c2.072-.01,4.144,0,6.217,0H19.182c.63,0,.906-.377.713-.97",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53672",
    "data-name": "Path 53672",
    d: "M28.082,134.007H10.148a.57.57,0,1,0,0,1.14h1.018c.08,1.074.167,2.147.254,3.22q.239,2.948.481,5.9c.149,1.824.289,3.648.447,5.471a1.6,1.6,0,0,0,1.685,1.536q5.05.006,10.1-.005a1.9,1.9,0,0,0,.75-.157,1.665,1.665,0,0,0,.958-1.551c.115-1.558.245-3.115.37-4.672q.215-2.673.433-5.346c.118-1.464.231-2.928.356-4.391h1.081a.57.57,0,0,0,0-1.14M15.044,149.624a.732.732,0,0,1-.531-.688c-.1-1.6-.2-3.2-.3-4.8q-.193-3.1-.384-6.205c-.024-.384-.046-.768-.068-1.151h-.014a2.722,2.722,0,0,1,.038-.447.754.754,0,0,1,.745-.558.738.738,0,0,1,.737.6,9.216,9.216,0,0,1,.086.972q.213,3.466.421,6.932.136,2.215.281,4.429c.044.669-.439,1.118-1.009.927m4.825-.879a.809.809,0,0,1-.526.875.768.768,0,0,1-1.021-.658c-.008-.091,0-.184,0-.276q0-2.984,0-5.968,0-3.047,0-6.093a.769.769,0,0,1,.531-.815.758.758,0,0,1,.974.5,1.358,1.358,0,0,1,.044.371q0,6.031,0,12.061m4.527-11.8q-.221,3.716-.443,7.432-.132,2.227-.262,4.454a.782.782,0,1,1-1.549-.09q.314-5.28.629-10.56c.033-.559.058-1.118.1-1.676a.76.76,0,0,1,.837-.74.777.777,0,0,1,.7.854c0,.109-.014.217-.022.325H24.4",
    transform: "translate(-9.097 -127.271)",
    fill: "#734bd1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.298374b47d50d9da79616a02ced64f99.svg";
export { ForwardRef as ReactComponent };